import "./App.css";
import Router from "./router/router.jsx";
import ScrollToTop from "./components/ScrollToTop";


function App() {
  return (
    <>
      <ScrollToTop /> 
      <Router />   
    </>
  );
}

export default App;
